import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import { CheckCircle2, ArrowRight, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState(null);
  const [polling, setPolling] = useState(true);
  const { clear } = useCart();

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        setStatus(r.data);
        if (r.data.payment_status === "paid") { setPolling(false); clear(); return; }
        if (tries++ >= 20) { setPolling(false); return; }
        setTimeout(poll, 1500);
      } catch { setPolling(false); }
    };
    poll();
    // eslint-disable-next-line
  }, [sessionId]);

  return (
    <div className="pt-40 pb-24 container-x max-w-2xl mx-auto text-center" data-testid="payment-success-page">
      <div className="glass rounded-3xl p-12">
        {polling ? (
          <>
            <Loader2 className="w-12 h-12 text-gold mx-auto animate-spin mb-6" />
            <h1 className="font-display text-3xl">Confirming your payment…</h1>
          </>
        ) : status?.payment_status === "paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-gold mx-auto mb-6" />
            <h1 className="font-display text-4xl">Order <em className="not-italic gold-text">Confirmed.</em></h1>
            <p className="mt-4 text-white/60">Thank you for choosing Batra Electronics. Your order confirmation and installation coordinator details will arrive by email.</p>
            <div className="mt-8 flex justify-center gap-3">
              <Link to="/" className="btn-gold">Return Home <ArrowRight className="w-4 h-4" /></Link>
              <Link to="/shop" className="btn-ghost-outline">Continue Shopping</Link>
            </div>
          </>
        ) : (
          <>
            <h1 className="font-display text-3xl">Payment status: {status?.payment_status || "unknown"}</h1>
            <p className="mt-4 text-white/60">If you were charged, please contact us with the session id.</p>
            <Link to="/" className="btn-ghost-outline mt-6">Home</Link>
          </>
        )}
      </div>
    </div>
  );
}
